<template>
  <v-card class="mt-8 pb-4">
    <v-card-title>基本資料</v-card-title>
    <v-card-text>
      <v-row>
        <v-col class="col-auto" cols="2" md="2">
          <v-text-field
            label="姓名"
            v-model="person.姓名"
            outlined
            dense
            hide-details
          >
          </v-text-field>
        </v-col>
        <v-col class="col-auto" cols="2" md="2">
          <v-text-field
            label="電話"
            v-model="person.電話"
            outlined
            dense
            hide-details
          >
          </v-text-field>
        </v-col>
        <v-col class="col-auto" cols="2" md="2">
          <v-text-field
            label="出生年月日"
            :value="person.出生年月日"
            outlined
            dense
            hide-details
            disabled
          >
          </v-text-field>
        </v-col>
        <v-col class="col-auto" cols="1" md="1">
          <v-text-field
            label="年齡"
            :value="年齡"
            outlined
            dense
            hide-details
            disabled
          >
          </v-text-field>
        </v-col>
        <v-col class="col-auto" cols="1" md="1">
          <v-text-field
            label="性別"
            :value="person.性別"
            outlined
            dense
            hide-details
            disabled
          >
          </v-text-field>
        </v-col>
        <v-col class="col-auto" cols="4" md="4">
          <v-row>
            <v-col class="col-auto">
              <v-checkbox
                v-model="person.原住民"
                dense
                label="原住民"
                hide-details
              >
              </v-checkbox>
            </v-col>
            <v-col class="col-auto">
              <v-checkbox
                v-model="person.獨老"
                dense
                label="獨老"
                hide-details
              >
              </v-checkbox>
            </v-col>
            <v-col class="col-auto">
              <v-checkbox
                v-model="person.慢簽"
                dense
                label="慢簽"
                hide-details
              >
              </v-checkbox>
            </v-col>
            <v-col class="col-auto">
              <v-checkbox
                v-model="person.小兒麻痹"
                dense
                label="小兒麻痹"
                hide-details
              >
              </v-checkbox>
            </v-col>
            <v-col class="col-auto">
              <v-checkbox
                v-model="person.不通知"
                dense
                label="不通知"
                hide-details
              >
              </v-checkbox>
            </v-col>
          </v-row>
        </v-col>

        <v-col class="col-auto" cols="2" md="2">
          <v-text-field
            label="行政區"
            v-model="person.行政區"
            outlined
            dense
            hide-details
          >
          </v-text-field>
        </v-col>
        <v-col class="col-auto" cols="10" md="10">
          <v-text-field
            label="地址"
            v-model="person.地址"
            outlined
            dense
            hide-details
          >
          </v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-btn large class="px-8 mx-2" color="primary" @click="update">
        修改資料
      </v-btn>
      <template v-if="無預約">
        <v-btn
          large
          class="px-8 mx-2"
          color="primary"
          :disabled="!anyMatch"
          @click="reserveDialog = true"
        >
          協助預約
        </v-btn>
      </template>
      <template v-else>
        <v-btn
          large
          class="px-8 mx-2"
          color="primary"
          @click="reserveDialog = true"
        >
          修改問卷
        </v-btn>
      </template>
    </v-card-actions>
    <question
      v-model="reserveDialog"
      :thePerson="person"
      @load="$emit('load')"
    />
  </v-card>
</template>

<script>
//
import util from "@/mixins/util";
import _ from "lodash";
import dayjs from "dayjs";
import question from "@/components/People/question.vue";
export default {
  name: "Basic",
  props: ["person"],
  mixins: [util],
  components: { question },
  data: () => ({
    reserveDialog: false,
  }),
  computed: {
    anyMatch() {
      return _.some(Object.values(this.person.篩檢項目), Boolean);
    },
    年齡() {
      return parseInt(
        dayjs().get("year") - 1911 - this.person.出生年月日 / 10000 + 1
      );
    },
    無預約() {
      return !this.person.地點 || !this.person.日期;
    },
  },
  methods: {
    async update() {
      if (confirm("確認修改資料？")) {
        try {
          await this.axios.post(
            `/dashboard/person/${this.person.身分證字號}`,
            this.person
          );
          this.$toast.success("修改成功");
          this.$emit("load");
        } catch (e) {
          this.$toast.error("修改失敗");
        }
      }
    },
  },
};
</script>
